// ** Initial State
const initialState = {
  allData: [],
  data: [],
  allLevels: [],
  sublevels: [],
  total: 1,
  params: {},
  selectedUser: null,
  intlref: {},
  allAcceptedFollowers: [],
  acceptedFollowers: [],
  acceptedFollowersTotal: 1,
  acceptedFollowersParams: {},
  RankedHistory: [],
  allHistory: [],
  history: [],
  historyTotal: 1,
  historyParams: {},
  allFollowers: [],
  followers: [],
  followersTotal: 1,
  followersParams: {},
  allCompetitions: [],
  competitions: [],
  competitionsTotal: 1,
  competitionsParams: {},
  allPosts: [],
  posts: [],
  postsTotal: 1,
  postsParams: {},
  allComments: [],
  allReplies: [],
  userRank: 0,
  notificationModal:false,
  notificationUser:null
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case "EMPTY_REDUCER":
      return initialState;
    case "INTL":
      return { ...state, intlref: action.data };
    case "GET_ALL_LEVELS":
      return { ...state, allLevels: action.data };
    case "GET_SUBLEVELS":
      return { ...state, sublevels: action.data };
    case "GET_ALL_DATA":
      return { ...state, allData: action.data };
    case "GET_DATA":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "GET_USER":
      return { ...state, selectedUser: action.selectedUser };
    case "ADD_USER":
      return { ...state };
    case "DELETE_USER":
      return { ...state };
    case "UPDATE_USER":
      return { ...state };
    case "GET_ALL_ACCEPTED_FOLLOWERS":
      return { ...state, allAcceptedFollowers: action.data };
    case "GET_ACCEPTED_FOLLOWERS":
      return {
        ...state,
        acceptedFollowers: action.data,
        acceptedFollowersTotal: action.totalPages,
        acceptedFollowersParams: action.params,
      };
    case "GET_ALL_FOLLOWERS":
      return { ...state, allFollowers: action.data };
    case "GET_FOLLOWERS":
      return {
        ...state,
        followers: action.data,
        followersTotal: action.totalPages,
        followersParams: action.params,
      };
    case "GET_RANKED_History":
      return { ...state, RankedHistory: action.data };

    case "GET_ALL_HISTORY":
      return { ...state, allHistory: action.data };
    case "GET_HISTORY":
      return {
        ...state,
        history: action.data,
        historyTotal: action.totalPages,
        historyParams: action.params,
      };

    case "GET_ALL_COMPETITIONS":
      return { ...state, allCompetitions: action.data };
    case "GET_COMPETITIONS":
      return {
        ...state,
        competitions: action.data,
        competitionsTotal: action.totalPages,
        competitionsParams: action.params,
      };

    case "GET_ALL_POSTS":
      return { ...state, allPosts: action.data };
    case "GET_POSTS":
      return {
        ...state,
        posts: action.data,
        postsTotal: action.totalPages,
        postsParams: action.params,
      };
    case "GET_All_COMMENTS":
      return { ...state, allComments: action.data };
    case "GET_All_REPLIES":
      return { ...state, allReplies: action.data };
    case "GET_RANK":
      return { ...state, userRank: action.userRank };
    case "UPDATE_STUDENT":
      return { ...state };
    case "NOTIFICATION_MODAL":
      let copyState={...state}
      let notificationState= copyState.notificationModal
      return { ...state, notificationModal: !notificationState ,notificationUser:action.data };
    default:
      return { ...state };
  }
};
export default users;
